export default __webpack_public_path__ + "static/media/BearingsImg.1db9272c.jpg";